import {
  TENANT_PORTAL_HIVE_PROSPECT_INTENT_COOKIE,
  TENANT_PORTAL_HIVE_PROSPECT_INTENT_STORAGE,
  WEBSITE_HIVE_PROSPECT_INTENT_MAX_AGE_SECONDS,
  WEBSITE_HIVE_PROSPECT_INTENT_QUERY,
  WEBSITE_HIVE_PROSPECT_INTENT_VALUE,
} from '../constants/website-hive-prospect-intent';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const prefix = `${name}=`;
  for (const part of document.cookie.split(';')) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length));
    }
  }
  return null;
}

function writePortalIntentCookie(): void {
  if (typeof document === 'undefined') return;
  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${TENANT_PORTAL_HIVE_PROSPECT_INTENT_COOKIE}=${WEBSITE_HIVE_PROSPECT_INTENT_VALUE}; Path=/; Max-Age=${WEBSITE_HIVE_PROSPECT_INTENT_MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
}

/** Persist Hive signup intent from the portal URL (cross-domain handoff from thehivekingston.com). */
export function rememberWebsiteHiveProspectIntent(search: string): void {
  const raw = new URLSearchParams(search).get(WEBSITE_HIVE_PROSPECT_INTENT_QUERY);
  if (raw === null) return;
  if (raw !== WEBSITE_HIVE_PROSPECT_INTENT_VALUE) {
    sessionStorage.removeItem(TENANT_PORTAL_HIVE_PROSPECT_INTENT_STORAGE);
    return;
  }
  sessionStorage.setItem(TENANT_PORTAL_HIVE_PROSPECT_INTENT_STORAGE, WEBSITE_HIVE_PROSPECT_INTENT_VALUE);
  writePortalIntentCookie();
}

export function hasPendingWebsiteHiveProspectIntent(): boolean {
  if (typeof window === 'undefined') return false;
  if (sessionStorage.getItem(TENANT_PORTAL_HIVE_PROSPECT_INTENT_STORAGE) === WEBSITE_HIVE_PROSPECT_INTENT_VALUE) {
    return true;
  }
  return readCookie(TENANT_PORTAL_HIVE_PROSPECT_INTENT_COOKIE) === WEBSITE_HIVE_PROSPECT_INTENT_VALUE;
}

export function clearPendingWebsiteHiveProspectIntent(): void {
  sessionStorage.removeItem(TENANT_PORTAL_HIVE_PROSPECT_INTENT_STORAGE);
  if (typeof document === 'undefined') return;
  document.cookie = `${TENANT_PORTAL_HIVE_PROSPECT_INTENT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
}
